import parseJson from '../parsers/parseJson';

const fromAnyToJsonClone = item => parseJson(JSON.stringify(item));

// noinspection JSUnusedGlobalSymbols
export default fromAnyToJsonClone;
